module.exports = __webpack_public_path__ + "static/img/20-1016-detail.114bf7a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/20-1016-detail.jpeg
// module id = wBMR
// module chunks = 0